import Vue from 'vue'

const state = {
  // 설정 > 기타설정 > 사용자 그룹 권한 설정
  baseUri: '/botw/config/userGroupPermission/'
}
const getters = {
}
const actions = {
  search: function (_context, [paramData, callback]) {
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: paramData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [id, callback]) {
    const reqData = JSON.parse(JSON.stringify(id))
    console.log('ConfigCodeGroup-detail', reqData)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + `detail/${reqData}`
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [paramData, callback]) {
    paramData = JSON.parse(JSON.stringify(paramData))
    const reqData = paramData
    console.log('ConfigCodeGroup-update', reqData)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
